<template v-if="isAuthenticated && userRole">
  <div :class="['sidebar', { collapsed: isMobile ? !sidebarVisible : false }]">
    <div class="sidebar-header mb-3">
      <div class="photobooth-logo">
        <span class="photo-text">PHOTO</span>
        <span class="booth-text">BOOTH</span>
      </div>
    </div>

    <ul class="menu">
      <li v-for="item in menuItems" :key="item.path">
        <template v-if="item.divider">
          <div class="menu-divider">{{ $t(item.title) }}</div>
        </template>
        <template v-else>
          <div class="mb-3">
            <router-link
              v-if="!item.children"
              :to="item.path"
              class="menu-item"
              active-class="active"
              exact-active-class="exact-active"
              @click="closeSidebar"
            >
              <i :class="'bi bi-' + item.icon"></i>
              <span class="ms-2">{{ $t(item.title) }}</span>
            </router-link>

            <div
              v-else
              class="menu-item dropdown"
              @click="toggleDropdown(item)"
            >
              <i :class="'bi bi-' + item.icon"></i>
              <span class="ms-2">{{ $t(item.title) }}</span>
              <i
                :class="
                  item.open ? 'bi bi-chevron-down' : 'bi bi-chevron-right'
                "
                class="ms-auto"
              ></i>
            </div>

            <ul v-if="item.children && item.open" class="submenu">
              <li v-for="child in item.children" :key="child.path">
                <router-link
                  :to="child.path"
                  class="submenu-item"
                  active-class="active"
                  exact-active-class="exact-active"
                  @click="closeSidebar"
                >
                  <i :class="'bi bi-' + child.icon"></i>
                  <span class="ms-2">{{ $t(child.title) }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    isAuthenticated: Boolean,
    isMobile: Boolean,
    sidebarVisible: Boolean,
    userRole: {
      type: String,
      required: true,
    },
  },
  data() {
    const allItems = [
      { title: "sidebar.dashboard", path: "/dashboard", icon: "grid" },
      {
        title: "sidebar.devices",
        icon: "hdd-stack",
        open: false,
        children: [
          { title: "sidebar.device_list", path: "/devices/list", icon: "list-ul" },
          { title: "sidebar.closed_days", path: "/devices/closed-days", icon: "calendar-x" },
          { title: "sidebar.inserted_coins", path: "/devices/inserted-coins", icon: "coin" },
          { title: "sidebar.cleared_days", path: "/devices/cleared-days", icon: "calendar-check" },
          { title: "sidebar.device_messages", path: "/devices/messages", icon: "chat-square-text" },
        ],
      },
      { title: "sidebar.templates", path: "/templates", icon: "list-ul" },
      { title: "sidebar.photos", path: "/photos", icon: "image" },
      {
        title: "sidebar.reports",
        icon: "bar-chart",
        open: false,
        children: [
          { title: "sidebar.photo_stats", path: "/reports/photo-stats", icon: "graph-up" },
          { title: "sidebar.revenue_analytics", path: "/reports/revenue-analytics", icon: "graph-up-arrow" },
        ],
      },
      { divider: true, title: "sidebar.profile" },
      { title: "sidebar.users", path: "/users", icon: "person-gear" },
      { title: "sidebar.settings", path: "/settings", icon: "gear" },
    ];

    return {
      menuItems: this.userRole === "device_maintainer"
        ? allItems.filter(item => item.path === "/dashboard")
        : allItems,
    };
  },
  methods: {
    closeSidebar() {
      if (this.isMobile) {
        this.$emit("close-sidebar");
      }
    },
    toggleDropdown(item) {
      item.open = !item.open;
    },
  },
};

</script>

<style scoped>
.menu {
  list-style: none;
  padding: 0;
  overflow-y: auto !important;
  max-height: 85vh;
  scrollbar-width: none;
}

.menu-item {
  display: flex;
  align-items: center;
  color: white;
  padding: 10px;
  text-decoration: none;
  margin: 5px 0;
  cursor: pointer;
}

.menu-item:hover {
  background-color: #495057;
}

.dropdown {
  display: flex;
  justify-content: space-between;
}

.submenu {
  list-style: none;
  padding-left: 20px;
}

.submenu-item {
  display: flex;
  align-items: center;
  color: white;
  padding: 8px;
  text-decoration: none;
}

.submenu-item:hover {
  background-color: #626c78;
}

.active {
  font-weight: bold;
}

.exact-active {
  font-weight: bold;
  border-left: 3px solid white;
}
</style>
